import { render, staticRenderFns } from "./WCSActivity.vue?vue&type=template&id=15d632ce&"
import script from "./WCSActivity.vue?vue&type=script&lang=js&"
export * from "./WCSActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports